import { render, staticRenderFns } from "./MobileBottomSheet.vue?vue&type=template&id=5cd34ed4&scoped=true"
import script from "./MobileBottomSheet.vue?vue&type=script&lang=js"
export * from "./MobileBottomSheet.vue?vue&type=script&lang=js"
import style0 from "./MobileBottomSheet.vue?vue&type=style&index=0&id=5cd34ed4&prod&lang=css"
import style1 from "./MobileBottomSheet.vue?vue&type=style&index=1&id=5cd34ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd34ed4",
  null
  
)

export default component.exports